import React, {useEffect, useState} from 'react';
import MessageModel, {ASSISTANT_CLASSES, ROLE, USER_CLASSES} from '../../models/message.model';
import Avatar from '../common/avatar';
import Cars from './Cars';
import Offers from './Offers';
import {linkifyUrlInText} from '../../services/utils.service';
import Locations from './Locations';
import Scheduler from './Scheduler';

const Message = ({data}: {data: MessageModel}) => {
	const isUser = data.role === ROLE.USER;
	const [showMessageText, setShowMessageText] = useState(true);

	useEffect(() => {
		setShowMessageText(!data.available_appointments?.length);
	}, []);

	return (
		<>
			{showMessageText &&
				<div className={`flex my-3 ${isUser ? 'justify-end' : ''}`}>
					{!isUser && <Avatar />}
					<div className={`p-4 pt-3.5 rounded flex ${isUser ? USER_CLASSES : ASSISTANT_CLASSES}`}>
						<span className="mt-0.5 whitespace-pre-line" style={{wordBreak: 'break-word'}} dangerouslySetInnerHTML={{__html: linkifyUrlInText(data.text)}}/>
					</div>
				</div>
			}
			{!!data.cars?.length && <Cars data={data.cars}/>}
			{!!data.offers?.length && <Offers data={data.offers}/>}
			{!!data.locations?.length && <Locations data={data.locations}/>}
			{!!data.available_appointments?.length && <Scheduler data={data.available_appointments}/>}
		</>
	);
};

export default Message;
